import React from 'react';
import { Container, ContainerMessage, TextLoding } from './style';
import { IconCached, Spinner } from 'takeat-design-system-ui-kit';

export function LoadingPage() {
  return (
    <Container>
      <ContainerMessage>
        <Spinner size={22} />
        <TextLoding>Carregando...</TextLoding>
      </ContainerMessage>
    </Container>
  );
}
